import React from 'react';
import {
  AgnesCard,
  AgnesCardContent,
  AgnesDataTable,
  type AgnesDataTableColumn,
  AgnesIconButton,
  AgnesPageHeader,
} from '@agnes/ui';
import { Eye, Table2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTabelasStore } from '@/stores/useTabelasStore';
import { authStorage } from '@/lib/authStorage';
import { TableWrapper } from '@/components/table-wrapper/TableWrapper';

type Tabela = Record<string, any>;

// TODO: precisa de API — fallback mock removido; dados reais vêm do BFF (useTabelasStore).
const tabelasMock: Tabela[] = [];

export default function PageTabelas() {
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(50);
  const lista = useTabelasStore((s) => s.lista);
  const carregando = useTabelasStore((s) => s.carregando);
  const navigate = useNavigate();

  React.useEffect(() => {
    // só busca no BFF se autenticado; sem token (dev) usa fallback mock e evita redirect ao login
    if (authStorage.getItem('access_Token')) useTabelasStore.getState().buscar();
  }, []);

  const data: Tabela[] = lista.length ? lista : tabelasMock;

  const columns: AgnesDataTableColumn<Tabela>[] = [
    { key: 'nome', header: 'Nome', width: 500, render: (r) => r.name ?? r.label ?? r.nome ?? '-' },
    { key: 'atualizacao', header: 'Atualização', width: 200, render: (r) => r.updatedAt ?? '-' },
    {
      key: 'atualizadoPor',
      header: 'Atualizado por',
      width: 220,
      render: (r) => r.updatedBy ?? '-',
    },
    {
      key: 'acoes',
      header: 'Ações',
      width: 90,
      align: 'center',
      render: (r) => (
        <AgnesIconButton
          aria-label="Visualizar"
          size="sm"
          onClick={() => navigate('/admin/tabelas/' + (r.config ?? r.slug))}
        >
          <Eye className="h-4 w-4" />
        </AgnesIconButton>
      ),
    },
  ];

  return (
    <>
      <AgnesPageHeader
        icon={<Table2 />}
        title="Tabelas"
        subtitle="Gerenciamento das atualizações dos leiautes do eSocial"
        breadcrumbs={[
          { label: 'Home', href: '/home' },
          { label: 'Configurações' },
          { label: 'eSocial' },
          { label: 'Tabelas' },
        ]}
      />

      <AgnesCard>
        <AgnesCardContent className="flex items-stretch">
          <TableWrapper>
            <AgnesDataTable<Tabela>
              columns={columns}
              data={data}
              rowKey={(r) => String(r.id ?? r.name)}
              loading={carregando}
              pagination={{
                page,
                pageSize,
                total: data.length,
                onPageChange: setPage,
                onPageSizeChange: (s) => {
                  setPageSize(s);
                  setPage(0);
                },
              }}
            />
          </TableWrapper>
        </AgnesCardContent>
      </AgnesCard>
    </>
  );
}
